import React from 'react';
import SearchComponent from './SearchComponent';
import Navbar from './Navbar';
import HeroBackground from '../assets/Rectangle 182.webp';

function Header() {
  return (
    <header className="relative text-white text-center">
      <Navbar />
      
      {/* Contenedor de la imagen con altura fija */}
      <div className="relative h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden">
        <img 
          src={HeroBackground} 
          alt="Hero Background" 
          className="absolute inset-0 w-full h-full object-cover" 
        />
        {/* Overlay oscuro opcional para mejor legibilidad */}
        <div className="absolute inset-0 bg-black/10"></div>
        
        {/* Título centrado verticalmente en la imagen */}
        <div className="absolute inset-0 flex items-center justify-center pt-16 md:pt-0">
          <h1 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-bold font-montserrat drop-shadow-2xl px-4 max-w-5xl leading-tight">
            Viaja, Disfruta y viví una vida llena de aventuras
          </h1>
        </div>
      </div>
      
      {/* Buscador que sobresale 1/4 fuera de la imagen */}
      <div className="relative -mt-20 md:-mt-24 lg:-mt-20 z-20 container mx-auto px-2 md:px-4">
        <div className="shadow-[0_10px_40px_rgba(0,0,0,0.6)] rounded-3xl">
          <SearchComponent />
        </div>
      </div>
    </header>
  );
}

export default Header;